import {Typography} from "@bolteu/clay-react";

import {useI18n} from "i18n/i18n";

import emailErrorLogo from "assets/email-error_3D.png";

import * as Styled from "./error.styled";

interface OwnProps {
    description?: string;
}

export const Error = ({description}: OwnProps) => {
    const i18n = useI18n();

    return (
        <Styled.Wrapper>
            <Styled.Message>
                <Styled.Icon>
                    <img alt="Email Error Icon" src={emailErrorLogo} />
                </Styled.Icon>
                <Typography className="bolt-font-heading-m-accent m-2">{i18n("webform.error.title")}</Typography>
                <Typography className="bolt-font-body-m-regular text-secondary text-center m-2">
                    {description ?? i18n("webform.error.generic_description")}
                </Typography>
            </Styled.Message>
        </Styled.Wrapper>
    );
};
